export const heroPropertyText = {
  en: {
    small: " ",
    main: "Property Investment Advisory",
  },
  vi: {
    small: " ",
    main: "Tư vấn Đầu tư Bất động sản",
  },
};

export const quotePropertyText = {
  en: {
    desc: `Turn every property decision into a profit-making opportunity. Our expert advisory helps you identify high-growth properties, minimize risks, and maximize returns, so your investments work harder for you.`,
    cta: "Contact us now ",
  },
  vi: {
    desc: `Biến mỗi quyết định đầu tư bất động sản thành cơ hội tạo lợi nhuận. Dịch vụ tư vấn chuyên sâu của chúng tôi giúp bạn nhận diện bất động sản tiềm năng, giảm thiểu rủi ro và tối đa hóa lợi nhuận, để khoản đầu tư của bạn hoạt động hiệu quả hơn.`,
    cta: "Liên hệ ngay ",
  },
};

export const propertyData = {
  en: [
    {
      id: 1,
      title: "Invest Smarter. Maximize Returns. Build Lasting Wealth.",
      description:
        "Property is one of the most powerful ways to grow wealth—but making the right investment decisions can be complex. Our Property Investment Advisory service helps business owners and investors identify high-return opportunities, mitigate risks, and achieve sustainable growth in their property portfolio.",
      list: [],
    },
    {
      id: 2,
      title: "How We Help You Achieve Maximum ROI",
      description: "",
      list: [
        "High-Value Property Identification: We pinpoint properties with strong capital growth and rental income potential.",
        "Investment Risk Management: Reduce exposure through in-depth market analysis and due diligence.",
        "Portfolio Optimization: Structure your investments to maximize returns and diversify risk.",
        "Tax & Financial Planning Support: Apply strategic financial approaches to enhance ROI.",
        "Long-Term Wealth Growth: Focus on sustainable investments that build lasting financial security.",
        "Hands-On Guidance: From acquisition to management, we ensure every property performs effectively.",
      ],
    },
    {
      id: 3,
      title: "Start Your Investment Journey",
      description: "",
      list: [
        "Whether you are new to property investment or expanding your portfolio, we help you make informed decisions that deliver high ROI and long-term financial success.",
        "Start your property investment journey today and turn opportunities into measurable growth and wealth.",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      title:
        "Đầu tư thông minh. Tối đa hóa lợi nhuận. Xây dựng tài sản bền vững.",
      description:
        "Bất động sản là một trong những kênh hiệu quả nhất để gia tăng tài sản, nhưng việc đưa ra quyết định đầu tư đúng không hề đơn giản. Dịch vụ Tư vấn Đầu tư Bất động sản của chúng tôi giúp nhà đầu tư và chủ doanh nghiệp xác định cơ hội sinh lời cao, giảm thiểu rủi ro và đạt được tăng trưởng bền vững cho danh mục đầu tư.",
      list: [],
    },
    {
      id: 2,
      title: "Cách chúng tôi giúp bạn tối đa hóa ROI",
      description: "",
      list: [
        "Xác định bất động sản giá trị cao: Lựa chọn tài sản có tiềm năng tăng giá và dòng tiền tốt.",
        "Quản lý rủi ro đầu tư: Giảm thiểu rủi ro thông qua phân tích thị trường và thẩm định kỹ lưỡng.",
        "Tối ưu danh mục đầu tư: Phân bổ chiến lược để tối đa hóa lợi nhuận và đa dạng hóa rủi ro.",
        "Hỗ trợ tài chính & thuế: Áp dụng chiến lược tài chính phù hợp để nâng cao hiệu quả đầu tư.",
        "Tăng trưởng tài sản dài hạn: Tập trung vào đầu tư bền vững và ổn định.",
        "Đồng hành thực tế: Hỗ trợ từ mua, quản lý đến tối ưu hiệu suất từng tài sản.",
      ],
    },
    {
      id: 3,
      title: "Bắt đầu hành trình đầu tư",
      description: "",
      list: [
        "Dù bạn mới bắt đầu hay đang mở rộng danh mục đầu tư, chúng tôi giúp bạn đưa ra quyết định đúng đắn để đạt ROI cao và thành công tài chính dài hạn.",
        "Bắt đầu hành trình đầu tư bất động sản ngay hôm nay và biến cơ hội thành tăng trưởng và tài sản thực tế.",
      ],
    },
  ],
};

export const propertyCTA = {
  en: {
    text: "Invest smart. Grow faster. Start today. ",
    button1: "Contact us now →",
  },
  vi: {
    text: "Đầu tư thông minh. Tăng trưởng nhanh hơn. Bắt đầu ngay hôm nay.",
    button1: "Liên hệ ngay →",
  },
};
